import { GetterTree } from 'vuex';
import { ApplicationType } from './applicationState.type';

export const getters: GetterTree<ApplicationType, any> = {
  appID: (state) => state.appID,
  appListingStatus: (state) => state.appListingStatus,
  isEditMode: (state) => state.isEditMode,
  appType: (state) => state.appType,
  stepsCompleted: (state) => state.stepsCompletedList,
  isPrivateApp: (state) => state.isPrivateApp,
};
